import Script from "next/script";

const APP_IDS = {
  dev: "1019419358082565",
  prod: "265704930120682",
};

const FacebookConnect = () => {
  return (
    <>
      <Script
        id="fb-connect"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.fbAsyncInit = function() {
              FB.init({
                appId            : '${APP_IDS.prod}',
                autoLogAppEvents : true,
                xfbml            : false,
                version          : 'v13.0'
              });
            };`,
        }}
      />
      <Script
        src="https://connect.facebook.net/en_US/sdk.js"
        strategy="lazyOnload"
      />
    </>
  );
};

export default FacebookConnect;
